import * as echarts from 'echarts';

import { ChartTypeEnum } from '@/bundles/Visualizations/enums/ChartTypeEnum';

// @ts-ignore
import EChartPie from '@/bundles/Visualizations/components/base/EChartPie.vue';
// @ts-ignore
import EChartBar from '@/bundles/Visualizations/components/base/EChartBar.vue';
// @ts-ignore
import EChartHorizontalBar from '@/bundles/Visualizations/components/base/EChartHorizontalBar.vue';
// @ts-ignore
import EChartBarLabelRotation from '@/bundles/Visualizations/components/base/EChartBarLabelRotation.vue';

export const ChartsDictionary = {
  [ChartTypeEnum.pie]: EChartPie,
  [ChartTypeEnum.bar]: EChartBar,
  [ChartTypeEnum.horizontalBar]: EChartHorizontalBar,
  [ChartTypeEnum.labelRotationBar]: EChartBarLabelRotation,
};

interface IProps {
  series?: echarts.SeriesOption;
}

interface IChartProps {
  series: echarts.SeriesOption;
}

export const getAdditionalPropsForChart = (props: IProps): IChartProps => {
  return {
    series: props.series || {},
  }
};
